<template lang="pug">
#Welcome(v-if="show")
    .only-screen
        span A great education in Victoria’s public school system begins at enrolment.
</template>

<script>
export default {
    name: 'Welcome',
    data: () => ({
        show: true,
    }),
    created() {
        window.app.Welcome = this;
    },
};
</script>

<style scoped>
#Welcome {
    color: white;
    background: #af2a32;
    padding: 2em 1em;
    font-size: 1.15em;
}
</style>
